import { render, staticRenderFns } from "./gateway-crm-account-confirmation-demo.vue?vue&type=template&id=1619a023&scoped=true&"
import script from "./gateway-crm-account-confirmation-demo.vue?vue&type=script&lang=js&"
export * from "./gateway-crm-account-confirmation-demo.vue?vue&type=script&lang=js&"
import style0 from "./gateway-crm-account-confirmation-demo.vue?vue&type=style&index=0&id=1619a023&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1619a023",
  null
  
)

export default component.exports